import React, { useContext, useEffect, useState } from 'react';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import {
  mockup_connection,
  mockup_connection_webp,
} from '../../../utils/images';
import '../../../css/login.css';
import { ProfileContext } from '../../Contexts/contexts';
import useToast from '../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import { useNavigate } from 'react-router';
import useAuth from '../../Contexts/useAuth';
import PreloadImage from '../../ImageLoader/ImageLoader';
import { EmailInput } from './EmailInput';
import { PasswordInput } from './PasswordInput';
import { CreatePassword } from './CreatePassword';
import { ChangeEmailLogin } from './changeEmailLogin';

export function Login() {
  const profileContext = useContext(ProfileContext);

  const { checkAuth } = useAuth();

  const enqueueToast = useToast();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const [userExists, setUserExists] = useState(false);

  const [clientExists, setClientExists] = useState(false);

  const [clientId, setClientId] = useState(undefined);

  const navigate = useNavigate();

  useEffect(() => {
    if (checkAuth('/login')) {
      if (profileContext.isLogged) navigate('/');
    }
  }, [profileContext, navigate, checkAuth]);

  const validateLoginForm = async () => {
    if (loading) return;

    if (!email.length) {
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });

      return;
    }

    if (!password.length) {
      enqueueToast(ToastMessages.PASSWORD_ERROR, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 10000,
      });

      return;
    }

    setLoading(true);

    const loginState = await profileContext.login(email, password);

    if (!loginState) {
      setLoading(false);
    }
  };

  return (
    <>
      <HeaderMinimal />
      <div className="login-main-container">
        <div className="login-left-side">
          <div className="title-container">
            <h1 className="login-title">
              Connectez-vous pour voir
              <br />
              vos devis et rendez-vous
            </h1>
          </div>
          {!clientExists ? (
            <EmailInput
              email={email}
              setEmail={setEmail}
              setUserExists={setUserExists}
              setClientExists={setClientExists}
              setClientId={setClientId}
            />
          ) : userExists ? (
            <>
              <ChangeEmailLogin
                email={email}
                setEmail={setEmail}
                setClientExists={setClientExists}
                setUserExists={setUserExists}
              />
              <PasswordInput
                password={password}
                setPassword={setPassword}
                validateLoginForm={validateLoginForm}
              />
            </>
          ) : (
            <>
              <ChangeEmailLogin
                email={email}
                setEmail={setEmail}
                setClientExists={setClientExists}
                setUserExists={setUserExists}
              />
              <CreatePassword
                clientId={clientId}
                setPassword={setPassword}
                validateLoginForm={validateLoginForm}
              />
            </>
          )}
        </div>
        <div className="login-right-side">
          <PreloadImage
            srcWebP={mockup_connection_webp}
            srcFallback={mockup_connection}
            alt="Illustration du tableau de bord CEC"
          />
        </div>
      </div>
    </>
  );
}

export default Login;
